import React from 'react';
import Proptypes from 'prop-types';

import 'components/ui/empty_state.scss';

const EmptyState = ({ title, subTitle, action: Action, image, children, inBlock, className, ...rest }) => {
  return (
    <div className="d-flex w-100 p-10">
      <div className={`empty-state ${inBlock ? 'in-block' : ''} ${className}`} {...rest}>
        {image && <img src={image} alt={title} />}
        <h3>{title}</h3>
        {subTitle && <p>{subTitle}</p>}
        {children}
        {Action && (
          <div className="action-container">
            <Action />
          </div>
        )}
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  title: Proptypes.string,
  subTitle: Proptypes.string,
  action: Proptypes.any,
  image: Proptypes.any,
};

EmptyState.defaultProps = {
  subTitle: null,
  action: null,
  image: null,
};

export default EmptyState;
